import { fromJS, List } from 'immutable';
import { ADD_QUIZ_SESSION_EVENTS } from '@instructure/quiz-common';
function addQuizSessionEvents(state, quizSessionEvents) {
  // in practice all events will share the same quizSessionId for now
  var quizSessionId = quizSessionEvents[0].quizSessionId;

  // add a new list or concat with a preexisting list
  return state.updateIn([quizSessionId], List(), function (events) {
    return events.concat(fromJS(quizSessionEvents));
  });
}
var defaultState = fromJS({});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ADD_QUIZ_SESSION_EVENTS:
      return addQuizSessionEvents(state, action.payload);
    default:
      return state;
  }
});